import React, { useState } from 'react';
import { useSelector} from 'react-redux';
import { Divider, Modal, Loader, Button } from 'rsuite';
import * as actionsPayment  from '../../../../app/actions/payment';
import {steppLabels} from './common/types';
import NuInsStepper from '../elements/NuInsStepper';
import { CheckBoxCustom } from '../elements/inputFields';
import {BackIcon, InfoIcon} from '../svg/iconsSvg';


const PaymentCashOnDelivery = ({onBack, onForward, style}) => {

    const state = useSelector(state => state);
    
    const { revisedOffer } = useSelector(state => state.insOffers);
    //const installments  = revisedOffer?.installments || [];

    const { installments, installmentsLEVA } = revisedOffer || {}; // for testing
    const payAmount = installments ? Number.parseFloat(installments[0]).toFixed(2) : null;
    const payAmountLEVA = installmentsLEVA ? Number.parseFloat(installmentsLEVA[0]).toFixed(2) : null;
    

    const [trueData, setTrueData] = useState(true);
    const [assignBroker, setAssignBroker] = useState(true);
    const [showNoSuccess, setShowNoSuccess] = useState(false);

    const [loading, setLoading]   = useState(false);

    const closeModal = () => setTrueData(true);
    const closeModalNoSuccess = () => setShowNoSuccess(false);
    
    const goBack = () => {
        onBack(14)
    }

    const handleSubmit = async () => {

        setLoading(true);

        const cashflowId = 1;

        let res;

        try { 
            res = await actionsPayment.makeCashOnDeliveryPayment(state, cashflowId);
        } 
        catch (error) { console.log(error);}

        console.log(res?.data);

        if(res?.data && res?.data.status === 0) {
            onForward(18)
        } else if (res?.data && res?.data.status === 1) {
            setShowNoSuccess(true);
            setLoading(false);
        }
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={4} steps={4} labels={steppLabels}/>              
            </div>
            <Divider style={{marginBottom: 0 , backgroundColor: '#6bdfa7', height: '.5px'}}/>
            <div className="payment-card">
                <div className="left">
                    <p style={{marginBottom: '8px'}}>Наложен платеж</p>
                </div>
                <div className="right">
                <p style={{marginBottom: '8px', opacity: '.7'}}>Сума за плащане</p>
                <p style={{fontWeight: '700', fontSize: '15px', paddingLeft: '8px'}}>{payAmount} € / {payAmountLEVA} лв.</p>
                </div>
            </div>
            
            <div className="steps_container-checkbox" style={{marginTop: '20px', marginBottom: '20px'}}>
                <div>
                    <InfoIcon size={22} />
                </div>
                <p style={{opacity: '.7'}}>При избран 'Наложен платеж', плащането се извършва при получаване на полицата от куриер </p>
            </div>

            <div className="steps_container-checkbox" style={{marginBottom: '20px'}}>
                <CheckBoxCustom onChange={(data)=> setAssignBroker(data)} value={assignBroker}/>
                <p>Възлагам на БРОКЕРА извършването на посредничество във връзка с избраните от мен продукти</p>
            </div>
         
            <div className="steps_container-checkbox" style={{marginBottom: '20px'}}>
                <CheckBoxCustom onChange={(data)=>setTrueData(data)} value={trueData}/>
                <p>Декларирам верността на подадените данни</p>
            </div>

            <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" onClick={()=>handleSubmit()}>Потвърждавам издаване на полица</button>

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}

            {/* Modal for true data */}
            <Modal size="xs" show={!trueData} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data">Не може да подадете данни с невярно съдържание</p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModal()} >OK</Button>
                </Modal.Footer>
            </Modal>
            {/* Modal for unsuccessfull cash on delivery */}
            <Modal size="xs" show={showNoSuccess} className="nuins-ok-modal" onHide={() => closeModalNoSuccess()}>
                <Modal.Body >
                    <p className="no-reg-data">Заявката е неуспешна, моля опитайте отново</p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModalNoSuccess()} >OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default PaymentCashOnDelivery;